import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-87783e52")

_pushScopeId("data-v-87783e52")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-lg-4 col-md-6 col-sm-12 login-form text-white" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-lg-8 col-md-10 col-sm-12" }
const _hoisted_9 = { class: "form-group text-left" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "form-group text-left" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createVNode("small", { class: "text-primary" }, " Forgot Your Password ? ", -1)
const _hoisted_16 = { class: "row justify-content-center" }
const _hoisted_17 = { class: "col-8" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-white" }, "Login", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "Sign Up", -1)
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-3\" data-v-87783e52><div class=\"col\" data-v-87783e52><small class=\"text-muted\" data-v-87783e52> This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\" data-v-87783e52>Privacy Policy</a> and <a href=\"https://policies.google.com/terms\" data-v-87783e52>Terms of Service</a> apply. </small></div></div>", 1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = /*#__PURE__*/_createVNode("button", { class: "btn-sat btn-lg squared text-white" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-male fa-3x" })
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Personal", -1)
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("button", { class: "btn-sat btn-lg squared text-white" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-building fa-3x" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Business ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Verify2fa = _resolveComponent("Verify2fa")
  const _component_TheBanner = _resolveComponent("TheBanner")
  const _component_Password = _resolveComponent("Password")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Verify2fa, {
      show: _ctx.showVerify,
      email: _ctx.loginForm.props.email,
      onClose: _ctx.close2fa,
      onSuccess: _ctx.success2fa
    }, null, 8, ["show", "email", "onClose", "onSuccess"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_TheBanner),
          _hoisted_5,
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("form", {
                id: "login",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop","prevent"]))
              }, [
                _createVNode("div", _hoisted_9, [
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loginForm.props.email = $event)),
                    "aria-describedby": "emailHelp",
                    placeholder: "Email"
                  }, null, 512), [
                    [_vModelText, _ctx.loginForm.props.email]
                  ]),
                  (_ctx.loginForm.controls.email.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.loginForm.controls.email.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_Password, {
                    style: {"width":"100%"},
                    inputStyle: "width:100%",
                    toggleMask: "",
                    feedback: false,
                    placeholder: "Password",
                    modelValue: _ctx.loginForm.props.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginForm.props.password = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.loginForm.controls.password.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.loginForm.controls.password.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_router_link, { to: { name: 'auth.forgot' } }, {
                    default: _withId(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("button", {
                      disabled: _ctx.loginForm.invalid || _ctx.blockButton,
                      type: "submit",
                      class: "btn-sat btn-block form-control"
                    }, [
                      _hoisted_18
                    ], 8, ["disabled"]),
                    (_ctx.isSmall)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args))),
                          type: "button",
                          class: "btn btn-block btn-light"
                        }, [
                          _hoisted_19
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_20
              ], 32)
            ])
          ])
        ])
      ]),
      _createVNode(_component_Dialog, {
        style: {"min-width":"300px"},
        header: "Sign Up",
        visible: _ctx.modalVisible,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalVisible = $event))
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("p", _hoisted_23, [
                _createVNode(_component_router_link, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalVisible = false)),
                  to: { name: 'auth.register' }
                }, {
                  default: _withId(() => [
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("p", _hoisted_28, [
                _createVNode(_component_router_link, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalVisible = false)),
                  to: { name: 'auth.register.business' }
                }, {
                  default: _withId(() => [
                    _hoisted_29,
                    _hoisted_30,
                    _hoisted_31
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
})